/**
 * @Author: hedongyang
 * @Date: 2024-02-04
 * @Description: 菲律宾Tagalog
 */
export default {
  name: "ph",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Malinaw",
      defaultLabel: "tagapili ng kulay",
      description: "kasalukuyang kulay ay {color}. pindutin ang enter upang pumili ng bagong kulay."
    },
    datepicker: {
      now: "Ngayon",
      today: "Ngayon",
      cancel: "Kanselahin",
      clear: "Malinaw",
      confirm: "OK",
      dateTablePrompt: "Gamitin ang mga arrow key at ipasok upang piliin ang araw ng buwan",
      monthTablePrompt: "Gamitin ang mga arrow key at ipasok upang piliin ang buwan",
      yearTablePrompt: "Gamitin ang mga arrow key at ipasok upang piliin ang taon",
      selectedDate: "Napiling petsa",
      selectDate: "Pumili ng petsa",
      selectTime: "Pumili ng oras",
      startDate: "Petsa ng Pagsisimula",
      startTime: "Oras ng Pagsisimula",
      endDate: "Petsa ng Pagtatapos",
      endTime: "Oras ng Pagtatapos",
      prevYear: "Nakaraang Taon",
      nextYear: "Next Year",
      prevMonth: "Nakaraang Buwan",
      nextMonth: "Next Month",
      year: "",
      month1: "Enero",
      month2: "Pebrero",
      month3: "Marso",
      month4: "Abril",
      month5: "Mayo",
      month6: "Hunyo",
      month7: "Hulyo",
      month8: "Agosto",
      month9: "Setyembre",
      month10: "Oktubre",
      month11: "Nobyembre",
      month12: "Disyembre",
      week: "linggo",
      weeks: {
        sun: "Araw",
        mon: "Mon",
        tue: "Mar",
        wed: "Wed",
        thu: "Hu",
        fri: "Biy",
        sat: "Sab"
      },
      weeksFull: {
        sun: "Linggo",
        mon: "Lunes",
        tue: "Martes",
        wed: "Miyerkules",
        thu: "Huwebes",
        fri: "Biyernes",
        sat: "Sabado"
      },
      months: {
        jan: "Jan",
        feb: "Peb",
        mar: "Mar",
        apr: "Abr",
        may: "Mayo",
        jun: "Jun",
        jul: "Hul",
        aug: "Ago",
        sep: "Sep",
        oct: "Okt",
        nov: "Nob",
        dec: "Disyembre"
      }
    },
    inputNumber: {
      decrease: "bawasan ang bilang",
      increase: "dagdagan ang bilang"
    },
    select: {
      loading: "Naglo-load",
      noMatch: "Walang tumutugmang data",
      noData: "Walang data",
      placeholder: "Piliin"
    },
    dropdown: {
      toggleDropdown: "I-toggle ang Dropdown"
    },
    cascader: {
      noMatch: "Walang tumutugmang data",
      loading: "Naglo-load",
      placeholder: "Piliin",
      noData: "Walang data"
    },
    pagination: {
      goto: "Pumunta sa",
      pagesize: "/pahina",
      total: "Kabuuan {total}",
      pageClassifier: "",
      page: "Pahina",
      prev: "Pumunta sa nakaraang pahina",
      next: "Pumunta sa susunod na pahina",
      currentPage: "pahina {pager}",
      prevPages: "Mga nakaraang pahina ng {pager}",
      nextPages: "Susunod na {pager} page",
      deprecationWarning: "Natukoy ang mga hindi na ginagamit na paggamit, mangyaring sumangguni sa dokumentasyon ng el-pagination para sa higit pang mga detalye"
    },
    dialog: {
      close: "Isara ang dialog na ito"
    },
    drawer: {
      close: "Isara ang dialog na ito"
    },
    messagebox: {
      title: "Mensahe",
      confirm: "OK",
      cancel: "Kanselahin",
      error: "Ilegal na input",
      close: "Isara ang dialog na ito"
    },
    upload: {
      deleteTip: "pindutin ang delete para tanggalin",
      delete: "Burahin",
      preview: "Silipin",
      continue: "Magpatuloy"
    },
    slider: {
      defaultLabel: "slider sa pagitan ng {min} at {max}",
      defaultRangeStartLabel: "piliin ang panimulang halaga",
      defaultRangeEndLabel: "pumili ng end value"
    },
    table: {
      emptyText: "Walang Data",
      confirmFilter: "Kumpirmahin",
      resetFilter: "I-reset",
      clearFilter: "Lahat",
      sumText: "Sum"
    },
    tree: {
      emptyText: "Walang Data"
    },
    transfer: {
      noMatch: "Walang tumutugmang data",
      noData: "Walang data",
      titles: ["Listahan 1", "Listahan 2"],
      filterPlaceholder: "Ipasok ang keyword",
      noCheckedFormat: "{total} mga bagay",
      hasCheckedFormat: "{checked}/{total} sinuri"
    },
    image: {
      error: "NABIGO"
    },
    pageHeader: {
      title: "Bumalik"
    },
    popconfirm: {
      confirmButtonText: "Oo",
      cancelButtonText: "Hindi"
    }
  }
};
